import { Divider } from "@mui/material";
import React, { FC } from "react";
import classes from "./Showcase.module.scss";
import { NanonetsBrand } from "../../../lib/images/logos";

const Showcase: FC = () => {
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <a href="https://nanonets.com/flow/home">
          <NanonetsBrand className={classes.brand} />
        </a>
        <div className={classes.subtitle}>
          Trusted by over 1000 businesses and counting
        </div>
        <div className={classes.logos}>
          <img
            src="https://cdn.nanonets.com/static/media/AmTrust.c6189c39367cd352f7fcaa2a7285a7f6.svg"
            alt=""
          />
          <img
            className={classes.sample}
            src="https://cdn.nanonets.com/static/media/Deloitte.c6e0cd37e3a4890314a06e64967595cb.svg"
            alt=""
          />
          <img
            className={classes.sample}
            src="https://cdn.nanonets.com/static/media/Divvy.49a84c5ed403992b3663b4c6a8848e13.svg"
            alt=""
          />
          <img
            className={classes.sample}
            src="https://cdn.nanonets.com/static/media/EY.ed4bb2c5f8589aa16ecbf67b02f5ed3c.svg"
            alt=""
          />
          <img
            className={classes.sample}
            src="https://cdn.nanonets.com/static/media/Hughes.70eb29c997fc2021b36a87257cef8922.svg"
            alt=""
          />
          <img
            className={classes.sample}
            src="https://cdn.nanonets.com/static/media/PnG.ac5e63d186fc52da178177612c792eb2.svg"
            alt=""
          />
          <img
            className={classes.sample}
            src="https://cdn.nanonets.com/static/media/Roche.dc07a6a4826f3fdf6d4b652c0d5f9655.svg"
            alt=""
          />
          <img
            className={classes.sample}
            src="https://cdn.nanonets.com/static/media/Toyota.6b210a43db628efb74ad90219097d695.svg"
            alt=""
          />
        </div>
        <div className={classes.numbers}>
          <div className={classes.block}>
            <div className={classes.value}>95%</div>
            <div className={classes.detail}>Straight-through Processing</div>
          </div>
          <Divider className={classes.divider} orientation="vertical" />
          <div className={classes.block}>
            <div className={classes.value}>80%</div>
            <div className={classes.detail}>Reduction in Overhead Costs</div>
          </div>
          <Divider className={classes.divider} orientation="vertical" />
          <div className={classes.block}>
            <div className={classes.value}>+32</div>
            <div className={classes.detail}>External Apps Supported</div>
          </div>
        </div>
        <div className={classes.rating}>
          <img
            src="https://cdn.nanonets.com/static/media/nanonets-rating.b6a6e9af4f75acb24418318265959688.svg"
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default Showcase;
